/** 域名配置状态 */
export enum EOemDomainStatus {
  /** 已配置 */
  Configured = 2,
  /** 未配置 */
  NotConfigured = 1,
}

export const oemDomainStatusLabel = {
  [EOemDomainStatus.Configured]: '已配置',
  [EOemDomainStatus.NotConfigured]: '未配置',
};

/** 品牌配置状态 */
export enum EOemBrandStatus {
  /** 已配置 */
  Configured = 2,
  /** 未配置 */
  NotConfigured = 1,
}

export const oemBrandStatusLabel = {
  [EOemBrandStatus.Configured]: '已配置',
  [EOemBrandStatus.NotConfigured]: '未配置',
};

/** 短签配置状态 */
export enum EOemSignatureStatus {
  /** 已配置 */
  Configured = 3,
  /** 未配置 */
  NotConfigured = 1,
  /** 审核中 */
  Audit = 2,
  /** 已驳回 */
  Reject = 4,
}

export const oemSignatureStatusLabel = {
  [EOemSignatureStatus.Configured]: '已配置',
  [EOemSignatureStatus.NotConfigured]: '未配置',
  [EOemSignatureStatus.Audit]: '审核中',
  [EOemSignatureStatus.Reject]: '已驳回',
};

/** oem启用状态 */
export enum EOemEnableStatus {
  /** 已启用 */
  On = 1,
  /** 已停用 */
  Off = 0,
}

export const oemEnableStatusLabel = {
  [EOemEnableStatus.On]: '已启用',
  [EOemEnableStatus.Off]: '已停用',
};

export const oemEnableStatusStyle = {
  [EOemEnableStatus.On]: 'success',
  [EOemEnableStatus.Off]: 'danger',
};

/** oem有效期状态 */
export enum EOemValidStatus {
  /** 未开始 */
  NotStart = 1,
  /** 有效期之内 */
  Normal = 2,
  /** 已到期 */
  Expired = 3,
}

export const oemValidStatusLabel = {
  [EOemValidStatus.NotStart]: '未开始',
  [EOemValidStatus.Normal]: '有效期之内',
  [EOemValidStatus.Expired]: '已到期',
};

export const oemValidStatusStyle = {
  [EOemValidStatus.NotStart]: 'warning',
  [EOemValidStatus.Normal]: 'success',
  [EOemValidStatus.Expired]: 'danger',
};

/** 代理商状态：0禁用、1启用 */
export enum EOemAgentStatus {
  /** 禁用 */
  Disabled = 0,
  /** 启用 */
  Enabled = 1,
}

export const oemAgentStatusLabel = {
  [EOemAgentStatus.Disabled]: '禁用',
  [EOemAgentStatus.Enabled]: '启用',
};

/** oem短签审批状态 */
export enum EOemSmsAuditStatus {
  /** 未配置 */
  NotConfigured = 1,
  /** 审核中 */
  Audit = 2,
  /** 已配置 */
  Configured = 3,
  /** 驳回 */
  Reject = 4,
}

export interface IOemDetail {
  /**
   * oem全局配置信息
   * @description {@link IOemDTO}
   */
  oemDTO?: IOemDTO;
  /**
   * oem域名相关配置
   * @description {@link IOemDnDTO}
   */
  oemDnDTO?: IOemDnDTO;
  /**
   * oem品牌方配置信息
   * @description {@link IOemBrandDTO}
   */
  oemBrandDTO?: IOemBrandDTO;
  /**
   * 短信签配置
   */
  oemSmsDTO?: IOemSmsDTO;
  /**
   * oem 是否为空
   * @default false
   */
  oemNull?: boolean;
}

/** 短信签配置 */
export interface IOemSmsDTO {
  /** 代理商短信签名 */
  signature: string;
  /** 短信签名备注 */
  remark: string;
  /**
   * 审批状态(2审核中 3已配置 4审核驳回)
   * @description {@link EOemSmsAuditStatus}
   */
  auditStatus: EOemSmsAuditStatus;
  /** 审核驳回原因 */
  auditMsg?: string;
}

/** oem品牌方配置信息 */
export interface IOemBrandMeta {
  /** 联系电话 */
  phone: string;
  /** 联系地址 */
  address: string;
  /** 邮箱 */
  email: string;
  /** 登录底图 */
  basePicture?: string;
  /** 网址logo */
  urlLogo: string;
  /** 菜单栏logo */
  menuLogo: string;
    /** 登录logo */
  loginLogo: string;
  /** 平台协议 */
  agreement: string;
  /** 平台协议名称 */
  agreementName: string;
  /** 隐私政策 */
  secretPolicy: string;
  /** 隐私政策名 */
  secretPolicyName: string;
}

export interface IOemDomainMeta {
  /** 域名 */
  domainName: string;
  /** 备案号 */
  recordNumber: string;
  /** sslKey文件地址 */
  sslKey: string;
  /** sslKey文件名 */
  sslKeyName: string;
  /** ssl证书地址 */
  sslCrt: string;
  /** ssl证书文件名 */
  sslCrtName: string;
}

/** oem品牌方配置信息 */
export interface IOemBrandDTO extends IOemBrandMeta {
  /** 品牌配置id */
  brandId: string;
  /** oem id */
  oemId: string;
}

export interface IOemDnDTO extends IOemDomainMeta {
  /** oem id */
  oemId: string;
  /** 域名配置id */
  dnId: string;
  /** 备案ip */
  ip: string;
}

/** oem全局配置信息 */
export interface IOemMeta {
  /** oem id */
  oemId: string;
  /**
   * 域名配置状态
   * @description {@link EOemDomainStatus}
   */
  dnStatus?: EOemDomainStatus;
  /**
   * 品牌配置状态
   * @description {@link EOemBrandStatus}
   */
  brandStatus?: EOemBrandStatus;
  /**
   * 短签配置状态
   * @description {@link EOemSignatureStatus}
   */
  smsStatus?: EOemSignatureStatus;
  /** 有效期开始时间 */
  validityStartTime?: string;
  /** 有效期结束时间 */
  validityEndTime?: string;
  /**
   * oem状态：0禁用、1启用
   * @description {@link EOemEnableStatus}
   */
  enabled?: EOemEnableStatus;
  /** 是否长期有效: 1 是， 0 否 */
  longTerm?: 0 | 1;
}

/** oem全局配置信息 */
export interface IOemDTO extends IOemMeta {
  /** 业务id */
  bizId: number;
  /**
   * oem有效期状态（1:未开始, 2:有效期之内, 3:已到期)
   * @description {@link EOemValidStatus}
   */
  validityStatus?: EOemValidStatus;
  /**
   * 代理商状态：0禁用、1启用
   * @description {@link EOemAgentStatus}
   */
  agentEnabled?: EOemAgentStatus;
}
